<template>
  <div id="country-flag">
    <template v-if="countrySrc">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <img v-bind="attrs" :src="countrySrc" :width="width" v-on="on" />
        </template>
        <span>
          {{ $t('views.stocks.stockTable.country') }}:
          {{ $te(`common.countries.${country}`) ? $t(`common.countries.${country}`) : country }}
        </span>
        <span v-if="exchange">
          <br />
          {{ $t('common.exchange') }}:
          {{ $t(`common.exchanges.${country}.${exchange}`) }}
        </span>
        <span v-if="exposureCountry">
          <br />
          {{ $t('views.stocks.stockTable.exposureCountry') }}:
          {{
            $te(`common.countries.${exposureCountry}`)
              ? $t(`common.countries.${exposureCountry}`)
              : exposureCountry
          }}
        </span>
      </v-tooltip>
    </template>
    <span v-else-if="country === 'FX'">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" :size="width + 1" class="country-flag-cash-icon" v-on="on">
            mdi-wallet
          </v-icon>
        </template>
        <span>{{ $t(`common.countries.${country}`) }}</span>
      </v-tooltip>
    </span>
    <span v-else-if="country === 'CC'">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" :size="width + 2" class="country-flag-crypto-icon" v-on="on">
            mdi-bitcoin
          </v-icon>
        </template>
        <span>{{ $t(`common.countries.${country}`) }}</span>
      </v-tooltip>
    </span>
    <span v-else-if="country === 'INDEX'">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" :size="width + 2" class="country-flag-index-icon" v-on="on">
            mdi-chart-line-variant
          </v-icon>
        </template>
        <span>{{ $t(`common.countries.${country}`) }}</span>
      </v-tooltip>
    </span>
    <span v-else-if="country === 'COMM'">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" :size="width + 2" class="country-flag-commodity-icon" v-on="on">
            mdi-gold
          </v-icon>
        </template>
        <span>{{ $t(`common.countries.${country}`) }}</span>
      </v-tooltip>
    </span>
    <span v-else-if="country" class="country-flag-text">
      {{ country }}
    </span>
    <span v-else-if="type === 'custom'">
      <v-icon class="country-flag-custom-icon">mdi-list-box</v-icon>
    </span>
    <span v-else>
      <v-icon class="country-flag-no-flag-icon" :size="width">
        mdi-diving-scuba-flag
      </v-icon>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    width: {
      type: Number,
      default: null,
    },
    country: {
      type: String,
      default: null,
    },
    exchange: {
      type: String,
      default: null,
    },
    exposureCountry: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
  },
  computed: {
    countrySrc() {
      try {
        return require(`@/assets/country/${this.country.toLowerCase()}.png`)
      } catch (error) {
        return null
      }
    },
  },
}
</script>

<style>
.country-flag-text {
  font-size: 14px;
  font-weight: 500;
}
.country-flag-no-flag-icon {
  padding-bottom: 2px;
  margin-right: 5px;
}
.country-flag-cash-icon {
  padding-bottom: 2px;
}
.country-flag-crypto-icon {
  padding-bottom: 1px;
}
.country-flag-index-icon {
  padding-bottom: 1px;
  margin-right: 3px;
}
.country-flag-commodity-icon {
  padding-bottom: 1px;
}
.country-flag-custom-icon {
  padding-bottom: 1px;
  margin-right: 3px;
}
</style>
